// кастомный компонент тултипа,где мы меняем цвета валюты и длаты при изменение темы:
// components/CustomTooltip.tsx

import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import React from 'react';

// ИСПРАВЛЕНО: Определяем интерфейс для элемента payload, чтобы не использовать any
interface RechartsPayload {
  value: number;
  // Можно добавить другие поля, если они понадобятся (например, dataKey, color, payload)
  // payload: { fullDate: number; value: number };
}

interface CustomTooltipProps {
  active?: boolean;
  // ИСПРАВЛЕНО: Используем типизированный массив вместо any[]
  payload?: RechartsPayload[];
  label?: number;
  currencyName: string;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
  currencyName,
}) => {
  if (!active || !payload || !payload.length) return null;

  const date = new Date(label || 0);
  const formattedDate = format(date, 'dd MMMM yyyy', { locale: ru });
  const value = payload[0].value;

  return (
    <div className="rounded-lg shadow-md px-4 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700">
      <p className="text-sm font-medium text-gray-800 dark:text-white">
        <span className="text-slate-700 dark:text-slate-100">{formattedDate}</span>
      </p>
      <p className="text-sm text-gray-700 dark:text-gray-300">
        <span className="text-green-600 dark:text-sky-400">{currencyName}</span> —{' '}
        <span className="font-bold text-lg">{value.toFixed(2)} ₽</span>
      </p>
    </div>
  );
};
